import { render, staticRenderFns } from "./UploadPreview.vue?vue&type=template&id=386fd072&"
import script from "./UploadPreview.vue?vue&type=script&lang=js&"
export * from "./UploadPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadPreview.vue"
export default component.exports